import { For, Show, type JSX } from 'solid-js';
import { SliderRow } from './SliderRow';
import type { SliderDef } from './SliderRow';
import './SettingsOverlay.css';

export type { SliderDef } from './SliderRow';

export interface SectionDef {
  title: string;
  sliders?: SliderDef[];
  children?: () => JSX.Element;
}

export interface SettingsOverlayProps {
  overlayId?: string;
  sectionClass?: string;
  sections: SectionDef[];
  visible: () => boolean;
  onToggle: () => void;
}

export function SettingsOverlay(props: SettingsOverlayProps): JSX.Element {
  const sectionClass = (): string => props.sectionClass ?? 'overlay-section';
  return (
    <div id={props.overlayId} class="settings-overlay" classList={{ hidden: !props.visible() }}>
      <For each={props.sections}>
        {(section) => (
          <>
            <div class="overlay-section-title">{section.title}</div>
            <div class={sectionClass()}>
              <Show when={section.sliders}>
                <For each={section.sliders}>
                  {(slider) => <SliderRow def={slider} />}
                </For>
              </Show>
              <Show when={section.children}>
                {section.children?.()}
              </Show>
            </div>
          </>
        )}
      </For>
    </div>
  );
}
